import { createAsyncThunk } from "@reduxjs/toolkit";

import { getFeature } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchFeatures = createAsyncThunk(
  "features/fetchFeatures",
  async (config: object, { getState, rejectWithValue }) => {
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await getFeature(token, baseUrl, {}, config);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
